import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/ui-kit";
import { PageHero, FinalCTA, CourseCard } from "@/components/blocks";
import { images, courses } from "@/data/site";

const filters = [
  { key: "all", label: "Tutti" },
  { key: "fitness", label: "Fitness" },
  { key: "olistica", label: "Olistica" },
  { key: "balli", label: "Balli" },
  { key: "kids", label: "Kids" },
];

export default function CorsiFitness() {
  const [active, setActive] = useState("all");
  const list = active === "all" ? courses : courses.filter((c) => c.category === active);

  return (
    <>
      <Seo title="Corsi Fitness a Lusciano | Body Evolution 2.0" description="Scopri i corsi fitness di Body Evolution 2.0: Functional, Spinning, GAG, Body Pump, Fit Box, MMA, Zumba, Latin Fit e molto altro." />
      <PageHero label="Corsi Fitness" title="Corsi fitness per allenarti con energia, metodo e motivazione" image={images.fitnessClass}
        text="I corsi fitness di Body Evolution 2.0 offrono allenamenti dinamici, coinvolgenti e strutturati. Ogni lezione dura 50 minuti ed è guidata da un istruttore dedicato, per migliorare forma fisica, resistenza, tono muscolare, coordinazione e benessere generale." />

      <section className="bg-ivory py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
          <div className="flex flex-wrap items-center justify-between gap-6">
            <SectionLabel>Filtra per categoria</SectionLabel>
            <div className="flex flex-wrap gap-2" data-testid="course-filters">
              {filters.map((f) => (
                <button
                  key={f.key}
                  data-testid={`filter-${f.key}`}
                  onClick={() => setActive(f.key)}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all ${
                    active === f.key ? "bg-ink-800 text-ivory" : "bg-white border border-black/10 text-ink-800/70 hover:border-gold"
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>
          </div>

          {active === "kids" ? (
            <Reveal>
              <div className="mt-12 bg-white border border-black/10 rounded-sm p-10 text-center">
                <h3 className="font-display text-2xl text-ink-800">Corsi Kids in fase di definizione</h3>
                <p className="mt-3 text-ink-800/60 max-w-xl mx-auto">Stiamo costruendo percorsi dedicati ai più piccoli, tra movimento, disciplina e crescita.</p>
                <Link to="/kids-family" className="mt-6 inline-flex items-center gap-2 text-gold font-semibold">Scopri Kids & Family <ArrowUpRight size={18} /></Link>
              </div>
            </Reveal>
          ) : (
            <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="courses-grid">
              {list.map((c, i) => <CourseCard key={c.slug} course={c} index={i} />)}
            </div>
          )}
        </div>
      </section>

      {/* Balli highlight */}
      <section className="bg-ink text-ivory grain py-24 relative">
        <div className="relative z-10 max-w-[1400px] mx-auto px-5 lg:px-10">
          <Reveal><SectionLabel dark>Balli & Movimento</SectionLabel></Reveal>
          <Reveal delay={0.1}><h2 className="mt-6 font-display font-medium tracking-tight text-3xl lg:text-4xl max-w-2xl">Energia, ritmo e socialità</h2></Reveal>
          <div className="mt-10 grid sm:grid-cols-2 gap-6">
            {courses.filter((c) => c.category === "balli").map((c, i) => (
              <Reveal key={c.slug} delay={i * 0.1}>
                <Link to={`/corsi/${c.slug}`} className="lift block bg-surface border border-white/10 rounded-sm p-8 hover:border-gold">
                  <div className="flex justify-between items-start"><h3 className="font-display text-2xl text-gold">{c.name}</h3><ArrowUpRight className="text-gold" /></div>
                  <p className="mt-3 text-ivory/60 text-sm">{c.short}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
